import React from 'react';
import {Box, Typography} from '@mui/material';

const NAVY   = '#052F44';
const ORANGE = '#FF6900';
const TEAL   = '#1B6B55';

const MODULE_ROWS = [
    {label: 'Digital Footprint',       pct: 82},
    {label: 'Online Safety Basics',    pct: 78},
    {label: 'Cyberbullying Response',  pct: 71},
    {label: 'Privacy & Data',          pct: 64},
    {label: 'Screen-time Balance',     pct: 58},
    {label: 'Reporting & Help-seeking',pct: 49},
];

const ModuleUsageTab = () => (
    <Box>
        <Box sx={{display: 'flex', gap: 2.5, alignItems: 'stretch'}}>

            {/* ── Left: Module completion bar chart ── */}
            <Box sx={{
                flex: '0 0 55%',
                border: '1px solid var(--brand-border, #E5E7EB)',
                borderRadius: '12px',
                backgroundColor: 'var(--brand-surface, #ffffff)',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                p: 3,
            }}>
                <Typography sx={{fontSize: '18px', fontWeight: 800, color: NAVY, mb: 3}}>
                    Module completion (% of assigned)
                </Typography>

                <Box sx={{display: 'flex', flexDirection: 'column', gap: 2}}>
                    {MODULE_ROWS.map((row) => (
                        <Box key={row.label} sx={{display: 'flex', alignItems: 'center', gap: 2}}>
                            {/* Module name */}
                            <Typography sx={{
                                fontSize: '14px',
                                color: '#374151',
                                minWidth: '190px',
                                flexShrink: 0,
                            }}>
                                {row.label}
                            </Typography>
                            {/* Bar track */}
                            <Box sx={{flex: 1, height: '22px', borderRadius: '4px', backgroundColor: 'var(--brand-surface-subtle, #E5E7EB)', overflow: 'hidden'}}>
                                <Box sx={{
                                    width: `${row.pct}%`,
                                    height: '100%',
                                    backgroundColor: '#1B4D8E',
                                    borderRadius: '4px',
                                    transition: 'width 0.4s ease',
                                }}/>
                            </Box>
                            {/* Percentage label */}
                            <Typography sx={{
                                fontSize: '15px',
                                fontWeight: 700,
                                color: NAVY,
                                minWidth: '42px',
                                textAlign: 'right',
                                flexShrink: 0,
                            }}>
                                {row.pct}%
                            </Typography>
                        </Box>
                    ))}
                </Box>

                {/* Footnote */}
                <Typography sx={{fontSize: '12px', color: '#9CA3AF', fontStyle: 'italic', mt: 3, lineHeight: 1.6}}>
                    Completion is activity, not impact — high completion does not by itself prove competency gain.
                </Typography>
            </Box>

            {/* ── Right: empty placeholder ── */}
            <Box sx={{
                flex: 1,
                border: '1px solid var(--brand-border, #E5E7EB)',
                borderRadius: '12px',
                backgroundColor: 'var(--brand-surface, #ffffff)',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                p: 3,
            }}>
                <Typography sx={{fontSize: '18px', fontWeight: 800, color: NAVY}}>
                    Module usage across the year
                </Typography>
            </Box>

        </Box>

        {/* Decision guidance footer */}
        <Box sx={{
            mt: 3,
            p: {xs: 2, md: 2.5},
            backgroundColor: 'var(--brand-surface-subtle, #EFF6FF)',
            border: '1px solid #BFDBFE',
            borderLeft: `4px solid ${NAVY}`,
            borderRadius: '0 8px 8px 0',
        }}>
            <Typography sx={{fontSize: '13px', color: '#374151', lineHeight: 1.7}}>
                <strong style={{color: NAVY}}>Decision guidance:&nbsp;</strong>
                Usage is rising steadily, but the started-vs-completed gap widens later in the cycle. Target
                enablement support at clients with low completion before reading any downstream outcome.
            </Typography>
        </Box>
    </Box>
);

export default ModuleUsageTab;
